export default __webpack_public_path__ + "static/media/ADIZ_01_mos.7f06fff0.wav";